/** 历史英文错误码 → 中文提示（兼容旧接口响应） */
const LEGACY_API_MESSAGE_ZH = {
  SYSTEM_ID_MISMATCH: '请选择正确系统',
  SYSTEM_MISMATCH: '请选择正确系统',
  SYSTEM_ID_REQUIRED: '请选择系统',
  SYSTEM_DISABLED: '该系统已停用',
  'Network Error': '网络连接失败，请稍后重试',
  'timeout of 60000ms exceeded': '请求超时，请稍后重试',
  'timeout of 600000ms exceeded': '上传超时，请检查文件大小或网络后重试',
  'Request failed with status code 403': '请求被拒绝，请检查网站防火墙或联系管理员',
  'Request failed with status code 502': '服务暂时不可用，请稍后重试'
}

export function resolveApiMessage(message) {
  if (!message) return '请求失败'
  if (LEGACY_API_MESSAGE_ZH[message]) return LEGACY_API_MESSAGE_ZH[message]
  if (/^Network Error$/i.test(message)) return LEGACY_API_MESSAGE_ZH['Network Error']
  if (/^timeout of \d+ms exceeded$/i.test(message)) {
    return message.includes('600000')
      ? LEGACY_API_MESSAGE_ZH['timeout of 600000ms exceeded']
      : LEGACY_API_MESSAGE_ZH['timeout of 60000ms exceeded']
  }
  if (/^服务器内部错误:/i.test(message)) return '操作失败，请稍后重试'
  return message
}

export function isSystemMismatchMessage(message) {
  const resolved = resolveApiMessage(message)
  return resolved === '请选择正确系统'
}
